import { CartUpdateEvent } from '@theme/events';
import { fetchConfig, startViewTransition } from '@theme/utilities';

/**
 * Runs the actual cart clear after the user has confirmed.
 */
async function clearCart() {
  const cartItemsComponent = /** @type {HTMLElement|null} */ (document.querySelector('cart-items-component'));
  if (!cartItemsComponent) return;

  const isDrawer = cartItemsComponent.hasAttribute('data-drawer');

  // Optimistic transition — mirrors onLineItemRemove for the last item
  const template = document.getElementById('empty-cart-template');
  if (template instanceof HTMLTemplateElement) {
    const clone = document.importNode(template.content, true);
    startViewTransition(() => {
      cartItemsComponent.replaceChildren(clone);
    }, [isDrawer ? 'empty-cart-drawer' : 'empty-cart-page']);
  }

  const sectionsToUpdate = new Set();
  document.querySelectorAll('cart-items-component').forEach((el) => {
    const sectionId = el instanceof HTMLElement && el.dataset.sectionId;
    if (sectionId) sectionsToUpdate.add(sectionId);
  });

  const body = JSON.stringify({
    sections: Array.from(sectionsToUpdate).join(','),
    sections_url: window.location.pathname,
  });

  try {
    const response = await fetch('/cart/clear.js', fetchConfig('json', { body }));
    const data = await response.json();

    document.dispatchEvent(
      new CartUpdateEvent(data, null, {
        itemCount: 0,
        source: 'cart-clear',
        sections: data.sections,
      })
    );
  } catch (error) {
    console.error('[cart-clear] Failed to clear cart:', error);
  }
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  // Open the confirmation dialog
  if (event.target.closest('.cart-clear-btn')) {
    const dialog = /** @type {HTMLDialogElement|null} */ (document.getElementById('cart-clear-confirm-dialog'));
    dialog?.showModal();
    return;
  }

  // Confirmed — clear the cart and close
  if (event.target.closest('[data-cart-clear-confirm]')) {
    const dialog = /** @type {HTMLDialogElement|null} */ (document.getElementById('cart-clear-confirm-dialog'));
    dialog?.close();
    clearCart();
    return;
  }

  // Cancelled
  if (event.target.closest('[data-cart-clear-cancel]')) {
    const dialog = /** @type {HTMLDialogElement|null} */ (document.getElementById('cart-clear-confirm-dialog'));
    dialog?.close();
  }
});
